import NotFoundAuth from './NotFoundAuth.js';

export default NotFoundAuth;
